import { clockPosition, type ClockPosition } from "@truckbuddy/contract";

/** Requested only on a deliberate punch or site-setup click; never tracked in the background. */
export function readClockPosition(): Promise<ClockPosition> {
  return new Promise((resolve, reject) => {
    if (!window.isSecureContext || !navigator.geolocation) {
      reject(new Error("Location needs HTTPS and a browser with location support."));
      return;
    }
    navigator.geolocation.getCurrentPosition((p) => {
      const result = clockPosition.safeParse({ latitude: p.coords.latitude, longitude: p.coords.longitude,
        accuracy: p.coords.accuracy, observedAt: new Date(p.timestamp).toISOString() });
      if (result.success) resolve(result.data);
      else reject(new Error("Your device returned an invalid location. Try again."));
    }, (error) => {
      reject(new Error(error.code === 1
        ? "Location access is blocked. Allow it in your browser and device settings, then try again."
        : "Your location is unavailable. Move near a window or outside and try again."));
    }, { enableHighAccuracy: true, maximumAge: 0, timeout: 20_000 });
  });
}

export function clockDuration(start: string, end: string | null, now: number): string {
  const minutes = Math.max(0, Math.floor(((end ? Date.parse(end) : now) - Date.parse(start)) / 60_000));
  return `${Math.floor(minutes / 60)}h ${String(minutes % 60).padStart(2, "0")}m`;
}
